// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"6868":"d7e14c1d7e9a1bcd","7482":"f3f976980a1b3e90"}[chunkId] + ".css";
};